module.exports = __webpack_public_path__ + "img/certification_mark.c7bf0b17.jpg";